/**
 * Portal ICAVI - Serviço de domínio: Aprovação da Produção
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const aprovacaoProducaoServiceMethods = {
    async listarSolicitacoesAprovacaoProducao(dataCadastro = null) {
        try {
            let url = '/api/aprovacao-producao/listar';
            if (dataCadastro) {
                url += `?data_cadastro=${dataCadastro}`;
            }
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar solicitações de aprovação da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async aprovarSolicitacoesProducao(dados) {
        try {
            const response = await api.post('/api/aprovacao-producao/aprovar', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao aprovar solicitações da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async rejeitarSolicitacoesProducao(dados) {
        try {
            const response = await api.post('/api/aprovacao-producao/rejeitar', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao rejeitar solicitações da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async voltarPendenteProducao(dados) {
        try {
            const response = await api.post('/api/aprovacao-producao/pendente', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao voltar solicitações para pendente:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async verificarStatusAprovacaoProducao(colaboradorId) {
        try {
            const response = await api.get(`/api/aprovacao-producao/verificar-status/${colaboradorId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao verificar status de aprovação da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async listarSolicitacoesAprovadasProducao() {
        try {
            const response = await api.get('/api/aprovacao-producao/listar-aprovadas');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar solicitações aprovadas da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterHistoricoAprovacaoProducao(colaboradorId) {
        try {
            const response = await api.get(`/api/aprovacao-producao/historico/${colaboradorId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter histórico de aprovação da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async configurarPermissaoAprovacaoProducao(dados) {
        try {
            const response = await api.post('/api/aprovacao-producao/configurar-permissao', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao configurar permissão de aprovação da produção:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async obterStatusBeneficios() {
        try {
            const response = await api.get('/api/beneficios/status');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter status de benefícios:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
